import React, { useContext } from "react";
import { IconButton, Tooltip } from "@mui/material";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import { StyleContext } from "../../context/styleContext";

export default function ThemeToggle({ className, size = "small" }) {
  const { colorMode, toggleColorMode } = useContext(StyleContext);
  const isDark = colorMode === "dark";

  return (
    <Tooltip title={isDark ? "Switch to light mode" : "Switch to dark mode"}>
      <IconButton
        className={className}
        size={size}
        onClick={toggleColorMode}
        aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
        sx={{
          color: "inherit",
          border: (theme) => `1px solid ${theme.palette.divider}`,
          borderRadius: 1,
          ml: 1,

          "&:hover": {
            backgroundColor: "action.hover",
          },
        }}
      >
        {isDark ? (
          <LightModeOutlinedIcon fontSize="small" sx={{ color: "#fbbf24" }} />
        ) : (
          <DarkModeOutlinedIcon fontSize="small" sx={{ color: "#4f46e5" }} />
        )}
      </IconButton>
    </Tooltip>
  );
}
